import React from "react";
import { FlatList, StyleSheet } from "react-native";
import { useRouter } from "expo-router";
import slugify from "slugify";

import { EventCard } from "@/screens/Content/Feed/EventsTab/Components/EventCard";
import { type EventOverview } from "@/schemas/events/EventOverview";
import { useEvents } from "@/screens/Content/Feed/EventsTab/Hooks/useEvents";
import { type ContentScreenState } from "@/schemas/screen/configs";
import { ContentTabs, Screen } from "@/schemas/screen/tabs";
import WebCard from "@/Components/Cards/WebCard";

export function EventFeed(): React.JSX.Element {
  const router = useRouter();

  const initialScreen: ContentScreenState = {
    screenId: Screen.CONTENT,
    activeTabId: ContentTabs.EVENTS,
    filters: null,
  };

  const { events } = useEvents(initialScreen);

  const handleEventPress = (event: EventOverview): void => {
    const eventSlug = `${event.id}-${slugify(event.title)}`;
    router.push(`/events/${eventSlug}`);
  };

  const styles = StyleSheet.create({
    container: {
      flex: 1,
      maxHeight: "100%",
    },
  });

  return (
    <FlatList
      style={styles.container}
      data={events}
      keyExtractor={(item) => item.id}
      renderItem={({ item }) => (
        <WebCard>
          <EventCard event={item} onPress={() => handleEventPress(item)} />
        </WebCard>
      )}
    />
  );
}
